module.exports = __webpack_public_path__ + "static/img/tutoriales sin texto utopie-3.2d5be354.jpg";